import { Button } from 'common.ui';
import Page from 'components/page/Page';
import React from 'react';

function HangfireDashboard() {
    const openHangfireDashboard = () => {
        // In development, open the Hangfire.Jobs application port
        // In production, this should be configured to point to the correct backend URL
        const hangfireUrl = process.env.NODE_ENV === 'development'
            ? 'https://localhost:7199/HangfireDashboard/login?returnUrl=/jobHub'
            : 'hangfire/HangfireDashboard/login?returnUrl=/hangfire/jobHub';

        window.open(hangfireUrl, '_blank');
    };

    return (
        <Page header='Hangfire Dashboard' title='Hangfire Dashboard'>
            <p>Click the button below to open the Hangfire Dashboard:</p>
            <Button
              text='Åpne Hangfire Dashboard'
              onClick={() => openHangfireDashboard()}
          />
        </Page>
    );
}
export default HangfireDashboard;
